import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../components/spinner";
import { formatMoneda } from "../util/varios.js";
import { DangerButton, SuccessButton } from "../ui/buttons/Button.jsx";

const CatalogoOrdenesPagosTerceroTipo = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO ORDEN", textAlign: "center" },
    { label: "Concepto", textAlign: "center" },
    { label: "FECHA", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              norden
                ? x.numordenpago.includes(target.value)
                : x.idordenpago.includes(target.value) ||
                  moment.utc(x.fecha).format("DD/MM/YYYY").includes(target.value) ||
                  formatMoneda(
                    x.montoordenpago.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  ).includes(target.value) ||
                  x.conceptoorden
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarOrdenesPagos = () => {
    let tipo = props.tipo;
    let endpoint = `${op.conexion}/api/catalogo/seleccionarordenesftecerosxtipo?idefi=${idefiscal}&tipo=${tipo}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var data = [];
          for (let i = 0; i < response.data.length; i++) {
            data.push({
              idproveedor: response.data[i].idproveedor,
              numordenpago: response.data[i].numordenpago,
              conceptoorden: response.data[i].conceptoorden,
              //ubicacion: response.data[i].ubicacion,
              fecha: response.data[i].fecha,
              idordenpago: response.data[i].idordenpago,
              tipo: response.data[i].tipo,
              montoordenpago: response.data[i].montoordenpago,
              //concepto: response.data[i].concepto,
            });
          }
          setRecords(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const selectOrden = () => {
    var numordenpago = values[0].numordenpago;
    var idproveedor = values[0].idproveedor;
    //var ubicacion = values[0].ubicacion;
    var fecha = values[0].fecha;
    var montoordenpago = values[0].montoordenpago;
    var idordenpago = values[0].idordenpago;
    var tipo = values[0].tipo;
    var conceptoorden = values[0].conceptoorden;

    blanquear();
    props.onHideAceptar(
      numordenpago,
      idproveedor,
      montoordenpago,
      fecha,
      conceptoorden,
      idordenpago,
      tipo
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var numordenpago = recordsAfterPagingAndSorting()[index].numordenpago;
    var conceptoorden = recordsAfterPagingAndSorting()[index].conceptoorden;
    var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
    //var ubicacion = recordsAfterPagingAndSorting()[index].ubicacion;
    var fecha = recordsAfterPagingAndSorting()[index].fecha;
    var montoordenpago = recordsAfterPagingAndSorting()[index].montoordenpago;
    var idordenpago = recordsAfterPagingAndSorting()[index].idordenpago;
    var tipo = recordsAfterPagingAndSorting()[index].tipo;
    //var concepto = recordsAfterPagingAndSorting()[index].concepto;

    var datos = [];
    datos.push({
      numordenpago,
      conceptoorden,
      idproveedor,
      //ubicacion,
      fecha,
      montoordenpago,
      idordenpago,
      tipo,
      //concepto
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarOrdenesPagos();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 fw-bold m-0 text-light">Seleccionar Orden Pago</h3>
        <button
          className="btn btn-sm bg-light"
          onClick={cancelar}
        >
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="input-group input-group-sm mb-3 m-0 col-5">
          <input
            type="text"
            onChange={handleSearch}
            className="form-control rounded-pill"
          />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "100px" }}>
                      {norden ? item.numordenpago : item.idordenpago}
                    </td>
                    <td className="py-2 text-center" style={{ width: "300px" }}>
                      {item.conceptoorden}
                    </td>
                    <td className="py-2 text-center" style={{ width: "10px" }}>
                      {moment.utc(item.fecha).format("DD/MM/YYYY")}
                    </td>
                    <td className="py-2 text-start" style={{ width: "150px" }}>
                      {formatMoneda(
                        item.montoordenpago.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={activo}
          onClick={selectOrden}
        >
           Aceptar
        </SuccessButton>
        <DangerButton
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
    </Modal>
  );
};
export default CatalogoOrdenesPagosTerceroTipo;
